import isEmpty from 'lodash/isEmpty'
import { useState } from 'react'
import type { CheckoutErrors } from '../types'

export const useCheckoutErrors = (): CheckoutErrors => {
  const [items, setItems] = useState<string[]>([])

  const push = (item: string | string[]) => {
    if (!Array.isArray(item)) {
      item = [item]
    }
    //now we set it to the set so that only unique values will be added
    // const set = new Set<string>([...items, ...item])
    setItems((prev) => Array.from(new Set<string>([...prev, ...item])))
  }

  const hasError = () => {
    return !isEmpty(items)
  }

  const reset = () => {
    setItems([])
  }

  return {
    items,
    push,
    hasError,
    reset,
  }
}
